import { render, staticRenderFns } from "./GreenFitOutSubTabs.vue?vue&type=template&id=4b93bd27&scoped=true&"
import script from "./GreenFitOutSubTabs.vue?vue&type=script&lang=js&"
export * from "./GreenFitOutSubTabs.vue?vue&type=script&lang=js&"
import style0 from "./GreenFitOutSubTabs.vue?vue&type=style&index=0&id=4b93bd27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b93bd27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b93bd27')) {
      api.createRecord('4b93bd27', component.options)
    } else {
      api.reload('4b93bd27', component.options)
    }
    module.hot.accept("./GreenFitOutSubTabs.vue?vue&type=template&id=4b93bd27&scoped=true&", function () {
      api.rerender('4b93bd27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/greenFitOut/GreenFitOutSubTabs.vue"
export default component.exports